<template>
  <div class="absolute right-3 bottom-34 z-100">
    <div
      class="flex flex-col cursor-pointer items-center justify-center p-2 bg-white rounded-lg w-12 h-12 text-2xl transition-colors active:bg-gray-50 select-none"
      v-on="$listeners"
    >
      <i class="text-base el-icon-refresh-right" />
      <p class="text-xxs">刷新</p>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "@nuxtjs/composition-api";

export default defineComponent({
  name: "L7Reset",
});
</script>

<style lang="scss" scoped>

</style>
